<template>
<v-container fluid grid-list-lg px-0>
    <v-layout>
      <v-flex xs9 v-if="fetchingInitData">
        <div class="text-xs-center mt-4">
          <v-progress-circular :size="80" color="primary" indeterminate />
        </div>
      </v-flex>
      <v-flex v-else xs9>
        <h3 class="mb-3">Индикативный план преподавателя: {{ currentTeacherFullname }} ({{ totalRating }} | засчитано - {{ totalRatingCounted }})</h3>
        <v-data-table light class="elevation-1" :headers="headers" :items="indicatorItems" :hide-actions="true" no-data-text="Список индикаторов пуст" :loading="loading">
          <template #items="indicatorRow">
            <!-- category -->
            <tr v-if="indicatorRow.item.type === 'category'" >
              <td :colspan="headers.length" class="subheading"><b>{{ indicatorRow.item.sequence }}. {{ indicatorRow.item.title[locale] }}</b></td>
            </tr>
            <!-- Single indicator -->
            <template v-else-if="!indicatorRow.item.parent && !indicatorRow.item.children">
              <tr>
                <td class="text-xs-center px-0" rowspan="2" style="vertical-align: top; text-align: center;">
                  <v-chip label small dark color="blue-grey">{{ categories[indicatorRow.item.category].sequence }}.{{ indicatorRow.item.sequence }}</v-chip>
                </td>
                <td :colspan="headers.length - 1" class="subheading pl-0">
                  {{ indicatorRow.item.title[locale] }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="text-sm-center">
                  <v-tooltip v-if="indicatorRow.item.kpi" top>
                    <template #activator="{ on }">
                      <v-icon color="warning" v-on="on" small style="cursor: pointer;">grade</v-icon>
                    </template>
                    <span>{{ $t('hints.kpi_indicator') }}</span>
                  </v-tooltip>
                </td>
                <td class="text-sm-center body-2 font-weight-bold">
                  <v-avatar v-if="currentValues[indicatorRow.item.id] && currentValues[indicatorRow.item.id].plan" size="32" color="teal" >
                    <span class="white--text">{{ currentValues[indicatorRow.item.id].plan | printFloat }}</span>
                  </v-avatar>
                </td>
                <td class="text-xs-center body-2">
                  {{ ((currentValues[indicatorRow.item.id] ? currentValues[indicatorRow.item.id].award : '') || '') | printFloat }}
                </td>
                <td class="text-xs-center body-2">
                  {{ ((currentValues[indicatorRow.item.id] ? currentValues[indicatorRow.item.id].counted : '') || '') | printFloat }}
                </td>
                <td>
                  <v-btn fab small color="info" :disabled="!currentTeacher || !currentValues[indicatorRow.item.id] || currentValues[indicatorRow.item.id].values.length === 0" @click="showIndicatorValues(indicatorRow.item)">
                    <v-icon>list</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <!-- Parent indicator -->
            <template v-else-if="!indicatorRow.item.parent && indicatorRow.item.children">
              <tr>
                <td class="px-0" :rowspan="indicatorRow.item.children ? Object.values(indicatorRow.item.children).filter(child => indicatorItems.findIndex(indicator => indicator.id === child.id) > 0).length + 1 : 1" style="vertical-align: top;">
                  <v-chip label small dark color="blue-grey">{{ categories[indicatorRow.item.category].sequence }}.{{ indicatorRow.item.sequence }}</v-chip>
                </td>
                <td colspan="6" class="subheading pl-0">
                  {{ indicatorRow.item.title[locale] }}
                </td>
              </tr>
            </template>
            <!-- Child indicator -->
            <template v-else>
              <tr>
                <td>
                  {{ indicatorRow.item.sequence }}) {{ indicatorRow.item.title[locale] }}
                </td>
                <td class="text-sm-center">
                  <v-tooltip v-if="indicatorRow.item.kpi" top>
                    <template #activator="{ on }">
                      <v-icon color="warning" v-on="on" small style="cursor: pointer;">grade</v-icon>
                    </template>
                    <span>{{ $t('hints.kpi_indicator') }}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-center body-2 font-weight-bold">
                  <v-avatar v-if="currentValues[indicatorRow.item.id] && currentValues[indicatorRow.item.id].plan" size="32" color="teal" >
                    <span class="white--text">{{ currentValues[indicatorRow.item.id].plan | printFloat }}</span>
                  </v-avatar>
                </td>
                <td class="text-xs-center body-2">
                  {{ ((currentValues[indicatorRow.item.id] ? currentValues[indicatorRow.item.id].award : '') || '') | printFloat }}
                </td>
                <td class="text-xs-center body-2">
                  {{ ((currentValues[indicatorRow.item.id] ? currentValues[indicatorRow.item.id].counted : '') || '') | printFloat }}
                </td>
                <td>
                  <v-btn fab small color="info" :disabled="!currentTeacher || !currentValues[indicatorRow.item.id] || currentValues[indicatorRow.item.id].values.length === 0" @click="showIndicatorValues(indicatorRow.item)">
                    <v-icon>list</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </template>
        </v-data-table>

        <v-dialog v-model="value.dialog" persistent lazy :max-width="500">
          <v-card>
            <v-card-title>
              <span class="headline">Значения индикатора</span>
            </v-card-title>
            <v-card-text>
              <value-form v-model="value.object" :readonly="true" @on-validate="value.valid = $event" :fields="indicatorFields(value.object.indicator)" :key="'indicator-' + value.object.indicator.id" />

              <v-textarea outline label="Комментарий" v-model="countedComment" :rows="1" :readonly="disableDepartmentSelection" :messages="countedCommentAuthor" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-text-field outline label="Балл" v-model="countedAward" :width="120" :readonly="disableDepartmentSelection" />
              <v-btn color="primary" flat @click="countValue(currentIndicator, value.object)" style="margin-left: 8px;" :disabled="disableDepartmentSelection">
                <template v-if="countedAward > 0">Засчитать</template>
                <template v-else>Сохранить</template>
              </v-btn>
              <v-btn color="red" flat @click="value.dialog = false">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="valuesList.dialog" persistent lazy :max-width="800">
          <v-card>
            <v-card-title>
              <span class="headline">Значения индикатора</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headersValue" :items="itemsValue" hide-actions :key="'values-list:' + currentIndicator.id" no-data-text="Еще нет ни одного значения">
                <template v-slot:items="valueRow">
                  <tr>
                    <td v-for="field in headersValue" :key="field.id" :class="{'no-wrap': field.id === 'actions','text-xs-center': ['award', 'counted'].indexOf(field.id) >= 0}">
                      <template v-if="field.id === 'actions'">
                        <v-btn flat icon color="primary" @click="showIndicatorValueForm(currentIndicator, valueRow.item.id)">
                          <v-icon>view_list</v-icon>
                        </v-btn>
                        <v-tooltip v-if="valueRow.item.comment" top>
                          <template #activator="{ on }">
                            <v-btn flat icon color="info" v-on="on">
                              <v-icon>info</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ valueRow.item.comment }} <br/>{{ valueRow.item.comment_author }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="field.id === 'award'">
                        {{ valueRow.item.award }}
                      </template>
                      <template v-else-if="field.id === 'counted'">
                        {{ valueRow.item.counted }}
                      </template>
                      <template v-else>
                        <template v-if="(currentIndicator.parent ? indicators[currentIndicator.parent].children[currentIndicator.id] : indicators[currentIndicator.id]).fields[field.id].type === 'enum'">
                          {{ (currentIndicator.parent ? indicators[currentIndicator.parent].children[currentIndicator.id] : indicators[currentIndicator.id]).fields[field.id].enums[valueRow.item.fields[field.id]].value[locale] }}
                        </template>
                        <template v-else>
                          {{ (valueRow.item.fields[field.id] ? valueRow.item.fields[field.id][locale] : '') || valueRow.item.fields[field.id] }}
                        </template>
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="red" flat @click="valuesList.dialog = false">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs3>
        <v-menu :nudge-right="40" full-width min-width="290px">
          <template #activator="{ on }">
            <v-text-field :label="$t('date')" v-model="filterTeachersTouchDate" prepend-icon="event" readonly v-on="on" />
          </template>
          <v-date-picker v-model="filterTeachersTouchDate" no-title scrollable :locale="$i18n.locale" />
        </v-menu>
        <v-autocomplete
            v-model="currentTeacher"
            label="Выберите преподавателя"
            @change="loadValues"
            :items="teachers"
            :item-text="teacherFullname"
            item-value="id"
            no-data-text="Список пуст"
        />
<!--        <v-select v-model="currentTeacher" label="Выберите преподавателя" @change="loadValues" :items="teachers" :item-text="teacherFullname" item-value="id" no-data-text="Список пуст"></v-select>-->
        <v-select v-model="currentDepartment" label="Выберите кафедру" :items="departments" :item-text="`title.${locale}`" item-value="code" :clearable="true" :disabled="disableDepartmentSelection"></v-select>
      </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { sortByLastname, sortByTitleLocale, sortBySequence, orderByCreatedDate, printFloat } from '@/plugins/helpers'
import { Indicator, IndicatorValue } from '@/api/indicators'
import settingsAPI from '@/api/settings'

import ValueForm from '@/components/forms/ValueForm'

import { mapState } from 'vuex'

export default {
  components: {
    ValueForm,
  },
  filters: {
    printFloat
  },
  data: (vm) => ({
    currentTeacher: null,
    currentDepartment: null,
    currentIndicator: new Indicator(),

    filterTeachersTouchDate: null,

    disableDepartmentSelection: false,
    totalRating: 0,
    totalRatingCounted: 0,

    countedAward: '',
    countedComment: '',
    countedCommentAuthor: '',

    allowedIndicators: [],

    totals: {},

    value: {
      dialog: false,
      object: new IndicatorValue({period: vm.$route.params.period})
    },
    valuesList: {
      dialog: false
    },

    loading: false,
    fetchingInitData: false,

    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: null
      },
      {
        text: 'Индикатор',
        align: 'left',
        sortable: false,
        value: 'title'
      },
      {
        text: 'Ключевой индикатор',
        align: 'center',
        sortable: false,
        class: 'multiline',
        value: null
      },
      {
        text: 'План',
        align: 'center',
        sortable: false,
        value: null
      },
      {
        text: 'Балл',
        sortable: false,
        value: null
      },
      {
        text: 'Засчитанно',
        sortable: false,
        value: null
      },
      {
        text: '',
        sortable: false,
        value: null
      }
    ]
  }),
  computed: {
    ...mapState('periods', {
      periods: state => state.periods
    }),
    locale () {
      return this.$i18n.locale
    },
    user () {
        return this.$store.state.user
    },
    isUserHead () {
        return this.$store.getters.isUserHead
    },
    userManagerRole () {
      return this.$store.getters.managerRole
    },
    ...mapState('teachers', {
      teachers (state) {
        let teachers = state.teachers.sort(sortByLastname)
        if (this.currentDepartment) {
          teachers = teachers.filter((teacher) => {
            return teacher.department.code === this.currentDepartment
          })
        }

        if (this.filterTeachersTouchDate) {
          const date = new Date(this.filterTeachersTouchDate)
          teachers = teachers.filter((teacher) => {
            const lastTouch = new Date(teacher['last_touch'])
            return lastTouch >= date
          })
        }

        return teachers
      }
    }),
    ...mapState('departments', {
      departments (state) {
        return Object.values(state.departments).sort(sortByTitleLocale(this.locale))
      }
    }),
    ...mapState('indicators', {
      categories: (state) => state.categories,
      indicators: (state) => state.indicators,
      values: (state) => state.valuesAll
    }),
    currentTeacherFullname () {
      const teacher = this.teachers.find((t) => {
        return t.id === this.currentTeacher
      })

      if (!teacher) {
        return ''
      }

      return this.teacherFullname(teacher)
    },
    indicatorItems () {
      let items = []

      Object.values(this.categories).sort(sortBySequence).forEach((category) => {
        items.push({...category, type: 'category'})
        Object.values(this.indicators).filter((indicator) => {
          return indicator.category === category.code
        }).sort(sortBySequence).forEach((indicator) => {
          items.push({...indicator, type: 'indicator'})

          if (indicator.children) {
            Object.values(indicator.children).sort(sortBySequence).forEach((child) => {
              items.push({ ...child, type: 'indicator' })
            })
          }
        })
      })

      if (this.userManagerRole) {
        const allowedIndicators = this.allowedIndicators || []
        if (allowedIndicators.length > 0) {
          return items.filter(item => allowedIndicators.includes(item.id ?? item.code))
        }
      }

      return items
    },
    headersValue () {
      if (this.currentIndicator.id === '') return []

      let indicator
      if (this.currentIndicator.parent) {
        indicator = this.indicators[this.currentIndicator.parent].children[this.currentIndicator.id]
      } else {
        indicator = this.indicators[this.currentIndicator.id]
      }

      const fields = indicator ? indicator.fields : {}

      let items =  Object.values(fields).sort(sortBySequence).filter((field) => {
        return field.listed
      }).map((field) => {
        return {
          id: field.id,
          text: field.title[this.locale],
          value: null,
          sortable: false,
        }
      })

      items.push({id: 'award', text: 'Балл', value: null, sortable: false, align: 'center', width: 120})
      items.push({id: 'counted', text: 'Засчитано', value: null, sortable: false, align: 'center', width: 120})
      items.push({id: 'actions', text: '', value: null, sortable: false, width: 152})

      return items
    },
    currentValues () {
      if (!this.currentTeacher) {
        return {}
      }
      return this.values[this.period] ? (this.values[this.period][this.currentTeacher] ? this.values[this.period][this.currentTeacher] : {}) : {}
    },
    itemsValue () {
      if (this.currentIndicator.id === '') return []

      let indicator
      if (this.currentIndicator.parent) {
        indicator = this.indicators[this.currentIndicator.parent].children[this.currentIndicator.id]
      } else {
        indicator = this.indicators[this.currentIndicator.id]
      }

      if (!indicator || !indicator.fields) {
        return []
      }

      if (!this.currentValues[indicator.id]) {
        return []
      }

      return Object.values(this.currentValues[indicator.id].values).sort(orderByCreatedDate)
    },
    period () {
      return this.$route.params.period
    }
  },
  watch: {
    period (current) {
      // if (current && this.currentTeacher) {
      //   this.loadValues()
      // }
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.fetchingInitData = true
      try {
        let role = this.userManagerRole ?? 'manager'

        await this.$store.dispatch('departments/getDepartments')
        await this.$store.dispatch('teachers/getAllTeachers', {role, period: this.period})

        await this.$store.dispatch('indicators/getIndicators', this.period)
        // this.loadValues()
        // if (this.user.department && this.isUserHead) {
        //   this.currentDepartment = this.user.department
        //   this.disableDepartmentSelection = true
        // }

        if (this.userManagerRole) {
          const role = {
            name: this.userManagerRole
          }
          const { indicators } = await settingsAPI.loadIndicatorsForRole(role)
          this.allowedIndicators = indicators
        }
      } catch (error) {
        console.error(error)
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }
      this.fetchingInitData = false
    },
    filterTeachers (item, queryText, itemText) {
      return itemText
    },
    updateTotals () {
      this.totals = {}
      this.totalRating = 0
      this.totalRatingCounted = 0
      console.log(this.currentValues)
      Object.keys(this.currentValues).forEach((val_id) => {
        let cat_id
        if (!this.currentValues[val_id].parent) {
          cat_id = this.indicators[val_id].category
        } else {
          cat_id = this.indicators[this.currentValues[val_id].parent].category
        }

        // const cat_id = this.indicators[val_id].category
        if (!this.totals[cat_id]) {
          this.totals = Object.assign(this.totals, {[cat_id]: {award: 0, counted: 0}})
        }
        this.totals[cat_id].award += this.currentValues[val_id].award
        this.totals[cat_id].counted += this.currentValues[val_id].counted

        this.totalRating += this.currentValues[val_id].award
        this.totalRatingCounted += this.currentValues[val_id].counted
      })
    },
    teacherFullname (teacher) {
      return [teacher.lastname, teacher.firstname, teacher.patronymic].join(' ')
    },
    loadValues () {
      this.loading = true
      this.$store.dispatch('indicators/getTeacherValues', {period: this.periods[this.period], teacher: this.currentTeacher}).then(() => {
        this.loading = false
        this.updateTotals()
        this.$events.$emit('notify', {
          message: 'Данные загружены',
          type: 'info'
        })
      }).catch((error) => {
        console.error(error)
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      })
    },
    showIndicatorValues (indicator) {
      this.$store.dispatch('indicators/getFieldsForIndicator', indicator).then(() => {
        this.currentIndicator = indicator
        if (indicator.single) {
          if (!this.currentValues[indicator.id]) {
            this.$events.$emit('notify', {
              message: 'Значение не установлено!',
              type: 'error'
            })
            return
          }
          if (Object.keys(this.currentValues[indicator.id].values).length <= 0) {
            this.$events.$emit('notify', {
              message: 'Значение не установлено!',
              type: 'error'
            })
            return
          }
          let value_id =  Object.keys(this.currentValues[indicator.id].values)[0]
          this.showIndicatorValueForm(indicator, value_id)
        } else {
          this.showIndicatorValuesList()
        }
      }).catch((error) => {
        console.error(error)
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
        this.currentIndicator = new Indicator()
      })
    },
    showIndicatorValuesList () {
      this.valuesList.dialog = true
    },
    showIndicatorValueForm (indicator, value_id) {
      this.value.object = new IndicatorValue({period: this.period})
      if (this.currentValues[indicator.id].values[value_id]) {
        const value = this.currentValues[indicator.id].values[value_id]
        this.value.object.id = value.id
        this.value.object.values = Object.assign({}, this.value.object.values, value.fields)
      }

      this.countedAward = this.currentValues[indicator.id].values[value_id].counted ?? this.currentValues[indicator.id].values[value_id].award
      this.countedComment = this.currentValues[indicator.id].values[value_id].comment ?? ''
      this.countedCommentAuthor = this.currentValues[indicator.id].values[value_id].comment_author ?? ''

      this.value.object.period = this.period
      this.value.object.indicator = new Indicator(indicator)
      this.value.dialog = true
    },
    indicatorFields (indicator) {
      let _indicator
      if (indicator.parent) {
        _indicator = this.indicators[indicator.parent].children[indicator.id]
      } else {
        _indicator = this.indicators[indicator.id]
      }

      if (!_indicator) {
        return []
      }
      return Object.values(_indicator.fields).sort(sortBySequence)
    },
    countValue (indicator, value) {
      this.$store.dispatch('indicators/countValue', { period: this.period, indicator, value, award: this.countedAward, comment: this.countedComment }).then(() => {
        this.loadValues()
        this.value.dialog = false
        this.$events.$emit('notify', {
          message: 'Значение засчитано',
          type: 'success'
        })
      }).catch((error) => {
        console.error(error)
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }).finally(() => {
        this.countedAward = 0
        this.countedComment = ''
      })
    },
  }
}
</script>

<style>
table.v-table thead th.multiline {
  white-space: normal;
}
</style>

<i18n>
{
  "ru": {
    "date": "Дата",
    "headers": {
      "indicator": "Индикатор",
      "kpi_indicator": "Ключевой индикатор",
      "award": "Баллы за единицу",
      "plan": "План",
      "submitted": "Количество работ",
      "award_pre": "Предварительный балл",
      "award_counted": "Засчитанный балл"
    },
    "hints": {
      "kpi_indicator": "Ключевой индикатор",
      "view_values": "Просмотр значений индикатора"
    },
    "alerts": {
      "plan_value_closed": "Внимание! Индикативный план закрыт. Внесение и изменение значений заблокировано!",
      "plan_plan_closed": "Внимание! Внесение плановых значений закрыто!",
      "plan_plan_due_date": "Внимание! Внесение плановых значений доступно до&nbsp;<b><u>{date}</u></b>",
      "plan_value_due_date": "Внимание! Внесение значений инидкаторов доступно до&nbsp;<b><u>{date}</u></b>"
    }
  },
  "kz": {
    "headers": {
      "indicator": "Көрсеткіш",
      "kpi_indicator": "Кілттік көрсеткіш",
      "award": "Бірлік үшін бағалау ұпайлары",
      "plan": "Жоспар",
      "submitted": "Орындалған жұмыс саны",
      "award_pre": "Алдын ала балл",
      "award_counted": "Балл"
    },
    "hints": {
      "kpi_indicator": "Кілттік көрсеткіш",
      "view_values": "Көрсеткіштің мәні"
    },
    "alerts": {
      "plan_value_closed": "Назар аударыңыз! Индикативті жоспар жабылды. Мәліметтерді енгізуге және өзгертуге тыйым салынды!",
      "plan_plan_closed": "Назар аударыңыз! Жоспарланған мәліметтерді енгізуге тыйым салынды!",
      "plan_plan_due_date": "Назар аударыңыз! Жоспарланған мәліметтерді&nbsp;<b><u>{date}</u></b>&nbsp;дейін енгізуге болады",
      "plan_value_due_date": "Назар аударыңыз! Мәліметтерді&nbsp;<b><u>{date}</u></b>&nbsp;дейін енгізуге болады"
    }
  }
}
</i18n>
